export default {
  'driver-out': 'Водитель выехал',
  'data-unavailable': 'Данные недоступны',
  delivered: 'Доставлено',
  'wrong-address': 'Неверный адрес',
  'not-present': 'Нет на месте',
  'order-canceled': 'Заказ отменён',
  'delivery-attempted': 'Попытка доставки',
  rescheduled: 'Перенесено',
  'date-unavailable': 'Дата недоступна',
}
